module.exports = __webpack_public_path__ + "img/gold.bb8bc9c.webp";